import { rem } from 'polished'
import MaskedInput from 'react-text-mask'
import styled from 'styled-components'

export const MaskedInputStyled = styled((props: any) => {
  const { inputRef, ...otherProps } = props
  return (
    <MaskedInput
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null)
      }}
      {...otherProps}
    />
  )
})`
  font-size: ${rem(16)};
`
